import { axiosClient } from '@/libs/axios-client';

const BASE = '/energy-tools';

export const fetchDefaultScenarios = async () => {
  const { data } = await axiosClient.get(`${BASE}/scenarios/default`);
  return data;
};

export const runAnalysis = async ({ files, name, plant, inputParameters }) => {
  const formData = new FormData();
  for (const file of files) {
    formData.append('files', file, file.name);
  }
  if (name) formData.append('name', name);
  if (plant?.name) formData.append('plantName', plant.name);
  if (plant?.capacityMw) formData.append('plantCapacityMw', plant.capacityMw);
  if (plant?.installedDcMw) formData.append('plantInstalledDcMw', plant.installedDcMw);
  if (plant?.location) formData.append('plantLocation', plant.location);

  if (inputParameters) {
    const append = (k, v) => {
      if (v !== null && v !== undefined && v !== '') {
        formData.append(k, String(v));
      }
    };
    append('capexEur', inputParameters.capexEur);
    append('batteryCapacityMwh', inputParameters.batteryCapacityMwh);
    append('batteryPowerMw', inputParameters.batteryPowerMw);
    append('purchaseCoefficient', inputParameters.purchaseCoefficient);
    append('spreadFilterMinEurMwh', inputParameters.spreadFilterMinEurMwh);
    append('maxCyclesYearlyRequested', inputParameters.maxCyclesYearlyRequested);
    append('cyclesPerYearEstimate', inputParameters.cyclesPerYearEstimate);
    append('ancillaryYearlyEur', inputParameters.ancillaryYearlyEur);
    append('projectLifetimeYears', inputParameters.projectLifetimeYears);
  }

  const { data } = await axiosClient.post(`${BASE}/analyze`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 180_000,
  });
  return data;
};

export const listAnalyses = async ({ limit = 50 } = {}) => {
  const { data } = await axiosClient.get(BASE, { params: { limit } });
  return data;
};

export const getAnalysis = async (id) => {
  const { data } = await axiosClient.get(`${BASE}/${id}`);
  return data;
};

export const downloadReport = async (id) => {
  const response = await axiosClient.get(`${BASE}/${id}/report.xlsx`, {
    responseType: 'blob',
  });
  return response.data;
};

export const deleteAnalysis = async (id) => {
  const { data } = await axiosClient.delete(`${BASE}/${id}`);
  return data;
};
